import axios from '../axios';

const endpoints = {
  invitationList: (params) => axios.get(`/invitation/invitation/`, {params}),
  invitationRetrieve: id => axios.get(`/invitation/invitation/${id}/`),
  invitationCreate: params => axios.post('/invitation/invitation/', params),
  invitationUpdate: ({id, ...params}) => axios.put(`/invitation/invitation/${id}/`, params),
  invitationDelete: id => axios.delete(`/invitation/invitation/${id}/`),
  invitationResendEmail: id => axios.post(`/invitation/invitation/${id}/resend_email/`),
  invitationUploadEndpoint: id => `${process.env.REACT_APP_API_URL}/invitation/upload/${id}/`,
  invitationUploadAnalyze: ({meetingId, data}) => axios.post(`/invitation/upload-analyze/${meetingId}/`, data),
  invitationUploadPreview: ({meetingId, data}) => axios.post(`/invitation/upload-preview/${meetingId}/`, data),
  invitationUploadConfirm: ({meetingId, data}) => axios.post(`/invitation/upload-confirm/${meetingId}/`, data),
};

export default endpoints;
